<micro-lookup domain="mail" obj="imaps" url="/mail/imap" [key]="imapMailboxId" [link]="link"></micro-lookup>
